import { t } from "@travily/i18n";
import { cx } from "@ui/utils/cx";

/**
 * Close button matched to the passport nav arrows (`passport-next.png`): a flat
 * #20262D disc with the same soft drop shadow, and a chunky, round-capped white X
 * whose stroke (9.5% of the disc) and ~49% span echo the rendered arrow — measured
 * from the arrow PNG, not eyeballed. Size + position come from `className` so each
 * surface can match its arrows / corner.
 */
export function PassportCloseButton({ onClose, className }: { onClose: () => void; className?: string }) {
  return (
    <button
      type="button"
      aria-label={t("passport.badges.modal.close")}
      className={cx(
        "absolute z-30 rounded-full bg-[#20262d] text-white shadow-[0_3px_8px_rgba(0,0,0,0.34)] outline-none transition hover:bg-[#2b333c] focus-visible:ring-2 focus-visible:ring-white",
        className,
      )}
      onClick={onClose}
    >
      <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" className="size-full">
        <path d="M34 34 66 66 M66 34 34 66" stroke="currentColor" strokeWidth="9" strokeLinecap="round" />
      </svg>
    </button>
  );
}
